var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"58.88 33.95 0 0 0 68 58.88 33.95","fillRule":"evenodd"}));
}

Play.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 58.88 68"};

module.exports = Play;

Play.default = Play;
